import React from "react";
import Chat from "./Chat/Chat";
import NestedComponent from "./NestedComponent";

const Moderator = () => {
  return (
    <div className="section_main_div">
      <div className="moderatorDiv">
        <div className="moderator-row row">
          <div className="chat-section col-md-6">
            <h3>Main Chat Feed</h3>
            <Chat />
          </div>
          <div className="nestedComponent col-md-6">
            <NestedComponent />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Moderator;
